import { IconShapeSocialPost } from 'src/assets/icons/shapes/IconShapeSocialPost';
import { IconShapeSocialStory } from 'src/assets/icons/shapes/IconShapeSocialStory';
import { IconShapeSquare } from 'src/assets/icons/shapes/IconShapeSquare';
import { IconShapeStandard } from 'src/assets/icons/shapes/IconShapeStandard';
import { IconShapeWidescreen } from 'src/assets/icons/shapes/IconShapeWidescreen';
import { IMAGE_ASPECT_RATIO } from 'src/data/image';

const IMAGE_ASPECT_RATIO_ICONS = {
  [IMAGE_ASPECT_RATIO.ratio1x1]: IconShapeSquare,
  [IMAGE_ASPECT_RATIO.ratio2x3]: IconShapeSocialPost,
  [IMAGE_ASPECT_RATIO.ratio3x2]: IconShapeStandard,
  [IMAGE_ASPECT_RATIO.ratio16x9]: IconShapeWidescreen,
  [IMAGE_ASPECT_RATIO.ratio9x16]: IconShapeSocialStory,
  [IMAGE_ASPECT_RATIO.ratio4x3]: IconShapeStandard,
};

export const ImageAspectRatioIcon = ({ className, aspectRatio }) => {
  const IconClass = IMAGE_ASPECT_RATIO_ICONS[aspectRatio];
  if (!IconClass) {
    return null;
  }

  return <IconClass className={className} />;
};
